import { blue, green, orange, red, royalblue, yellow } from "../theme";
import {
  ClinicalRisk,
  Consciousness,
  Frailty,
  InfectiousSymptom,
  Pain,
} from "./types";

export const WORK_OFFLINE = false;
export const ENABLE_AI_NOTES = false;

export const CONSC_LABELS = {
  [Consciousness.NA]: "N/A",
  [Consciousness.ALERT]: "Alert",
  [Consciousness.CONFUSED]: "Confused",
  [Consciousness.VERBAL]: "Verbal",
  [Consciousness.PAINFUL]: "Painful",
  [Consciousness.UNRESP]: "Unresp.",
};

export const FRAILTY_LABELS = {
  [Frailty.VERY_FIT]: "Very Fit",
  [Frailty.WELL]: "Well",
  [Frailty.MANAGING_WELL]: "Managing Well",
  [Frailty.VULNERABLE]: "Vulnerable",
  [Frailty.MILDLY_FRAIL]: "Mildly Frail",
  [Frailty.MODERATELY_FRAIL]: "Moderately Frail",
  [Frailty.SEVERELY_FRAIL]: "Severely Frail",
  [Frailty.VERY_SEVERELY_FRAIL]: "Very Severely Frail",
  [Frailty.TERMINALLY_ILL]: "Terminally Ill",
  [Frailty.NOT_SURE]: "Not Sure",
};

export const PAIN_LABELS = {
  [Pain.NO_PAIN]: "None",
  [Pain.VERY_MILD]: "Minimal",
  [Pain.DISCOMFORTING]: "Minimal",
  [Pain.TOLERABLE]: "Mild",
  [Pain.DISTRESSING]: "Mild",
  [Pain.VERY_DISTRESSING]: "Moderate",
  [Pain.INTENSE]: "Moderate",
  [Pain.VERY_INTENSE]: "Severe",
  [Pain.HORRIBLE]: "Severe",
  [Pain.UNBEARABLE]: "Extreme",
  [Pain.UNSPEAKABLE]: "Extreme",
};

export const RISK_LABELS = {
  [ClinicalRisk.LOW]: {
    title: "Low risk",
    description: "",
  },
  [ClinicalRisk.LOW_MEDIUM]: {
    title: "Low-Medium risk",
    description:
      "Urgent review by senior ED nurse, to decide best ED location, " +
      "frequency of clinical monitoring or escalation of care",
  },
  [ClinicalRisk.MEDIUM]: {
    title: "Medium risk",
    description:
      "Urgent review by a senior ED nurse, registrar or consultant, to " +
      "decide best ED location and escalation of care",
  },
  [ClinicalRisk.HIGH]: {
    title: "High risk",
    description:
      "Emergency assessment by a clinical team including ED registrar or " +
      "consultant and transfer to resuscitation area for escalation of care",
  },
};

export const RISK_COLOURS = {
  [ClinicalRisk.LOW]: { main: "#dddee0", light: royalblue[50] },
  [ClinicalRisk.LOW_MEDIUM]: { main: "#fdf2b3", light: yellow[50] },
  [ClinicalRisk.MEDIUM]: { main: "#f5ca92", light: orange[100] },
  [ClinicalRisk.HIGH]: { main: "#e89a86", light: red[100] },
};

export const ATS_COLOURS = [
  {
    text: red[900],
    background: red[25],
    backgroundBright: red[50],
    border: red[500],
  },
  {
    text: yellow[900],
    background: yellow[25],
    backgroundBright: yellow[50],
    border: yellow[500],
  },
  {
    text: green[900],
    background: green[25],
    backgroundBright: green[50],
    border: green[500],
  },
  {
    text: blue[900],
    background: blue[25],
    backgroundBright: blue[50],
    border: blue[500],
  },
  {
    text: royalblue[900],
    background: royalblue[25],
    backgroundBright: royalblue[50],
    border: royalblue[500],
  },
];

export const PAIN_TYPES = Object.values(Pain)
  .filter((pain) => !isNaN(Number(pain)))
  .map((pain) => ({
    label: `${pain} - ${PAIN_LABELS[pain as Pain]}`,
    value: pain,
  }));

export const FRAILTY_TYPES = Object.values(Frailty)
  .filter((frailty) => !isNaN(Number(frailty)))
  .map((frailty) => ({
    label: FRAILTY_LABELS[frailty as Frailty],
    value: frailty,
  }));


// Text that indicates whether the information was provided by the delegate
// or if it differs to what is on the patient object.
export const DELEGATE_INFO = {
  PROVIDED: "Value provided by delegate",
  DIFFERS: "Delegate provided:",
};

export const SYMPTOM_LABELS = {
  [InfectiousSymptom.FEVER]: "Fever",
  [InfectiousSymptom.COUGH]: "Cough",
  [InfectiousSymptom.SHORTNESS_OF_BREATH]: "Shortness of breath",
  [InfectiousSymptom.RUNNY_NOSE]: "Runny nose",
  [InfectiousSymptom.SORE_THROAT]: "Sore throat",
  [InfectiousSymptom.DIARRHOEA]: "Diarrhoea",
  [InfectiousSymptom.COVID]: "Known COVID-19",
  [InfectiousSymptom.CHEMO]: "Chemo or Immunotherapy",
};
